<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Intermediadores de pagamento</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/financas">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Intermediadores de pagamento são os intermediários entre as operadoras de cartões e a sua
                            empresa. Exemplo: Cielo, Rede, etc.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else {
                    <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    <button mat-menu-item [disabled]="!selection.hasValue()" (click)="abrirModalExcluir()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir</span>
                    </button>
                </mat-menu>

                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/financas/intermediador-pagamento/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Novo Intermediador
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Busque pela descrição do intermediador">

                        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="col-md-6 filter-container">
                    <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
                        [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
                        <mat-icon>filter_list</mat-icon>
                        Filtrar
                    </button>
                    <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                        <div class="filter-menu-content" [formGroup]="model">
                            <div (click)="$event.stopPropagation()">
                                <h6>Filtros Avançados</h6>

                                <div class="filter-menu__form">
                                    <app-select-pesquisavel label="Tipo de intermediador"
                                        [control]="$any(model.get('listIdAdquirente'))" [idField]="'id'"
                                        [nameField]="'descricao'" [offlineList]="adquirentesDisponiveis"
                                        [multiple]="true" [isOptional]="true" hint="Selecione um ou mais tipos">
                                    </app-select-pesquisavel>
                                </div>
                            </div>

                            <div class="filter-menu__actions">
                                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                                    Aplicar
                                </button>
                            </div>
                        </div>
                    </mat-menu>

                    <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                        <mat-icon>cleaning_services</mat-icon>
                        Limpar Filtros
                    </button>
                </div>
            </div>
        </form>

        @if(_isLoading && !_dataSource.data.length) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if(_dataSource.data.length > 0) {
        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
                <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
            </ng-container>

            <ng-container matColumnDef="tipoIntermediador">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo intermediador</th>
                <td mat-cell *matCellDef="let element">{{ element.tipoIntermediador }}</td>
            </ng-container>

            <ng-container matColumnDef="contaFinanceira">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Conta financeira</th>
                <td mat-cell *matCellDef="let element">{{ element.contaFinanceira }}</td>
            </ng-container>

            <ng-container matColumnDef="situacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge" [ngClass]="element.situacao === 'ATIVO' ? 'badge-verde' : 'badge-cinza'">
                        {{ element.situacao === 'ATIVO' ? 'Ativo' : 'Inativo' }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/intermediador-pagamento/cadastrar', element.id]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="abrirModalExcluir(element)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of _dataSource.data; track item.id) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary">
                        </mat-checkbox>
                        <div>
                            <div class="text-bold">{{ item.descricao }}</div>
                        </div>
                    </div>

                    <button mat-icon-button [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/financas/intermediador-pagamento/cadastrar', item.id]">
                            Editar
                        </button>
                        <button mat-menu-item (click)="abrirModalExcluir(item)">Excluir</button>
                    </mat-menu>
                </div>

                <div class="card-body-mobile">
                    <div class="card-row-mobile">
                        <span class="text-secondary">Tipo intermediador</span>
                        <span>{{ item.tipoIntermediador }}</span>
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Conta financeira</span>
                        <span>{{ item.contaFinanceira }}</span>
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Situação</span>
                        <span class="status-badge"
                            [ngClass]="item.situacao === 'ATIVO' ? 'badge-verde' : 'badge-cinza'">
                            {{ item.situacao === 'ATIVO' ? 'Ativo' : 'Inativo' }}
                        </span>
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button class="btn-ver-mais" [disabled]="!temMaisRegistros" (click)="proximaPagina()">
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
            </button>
        </div>
        } @else {
        <app-empty-list [title]="'Nenhum intermediador encontrado'"
            [subTitle]="'Nenhum item corresponde aos filtros informados'"></app-empty-list>
        }
    </div>
</div>
